const BUSCANDO = (state, payload) => {
    state.buscando = payload
  }

const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const LISTAR_CPE = (state, payload) => {
  state.cpe = payload
}

  export {
    LISTAR_CPE,
    BUSCANDO,
    LISTAR_DADOS
  }